export const NAMESPACE = "SettingsIntegrations";

export const CONTAINER_HEIGHT = 250;
